<template>
  <div class="my-4">
    <div class="div-container">
      <div class="row">
        <div class="col-12 col-md-3">
          <div class="d-flex">
            <div class="label">Tipo de Programa:</div>
            <div>{{ item.programType.name }}</div>
          </div>
        </div>
        <div class="col-12 col-md-2">
          <div class="d-flex">
            <div class="label">Programa:</div>
            <div>{{ item.program.name }}</div>
          </div>
        </div>
        <div class="col-12 col-md-2">
          <div class="d-flex">
            <div class="label">Presupuesto:</div>
            <div>{{ item.projectedFund | price }}</div>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="d-flex">
            <div class="label">Número de Cifra:</div>
            <div>{{ fullNumber }}</div>
          </div>
        </div>
        <div v-if="!isReadOnly" class="col-md-1 text-right">
          <i class="fal fa-times-circle text-danger" @click="remove(item)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import alertMixin from '@/mixins/alert.mixin.js';
import governmentLevels from '@/utils/constants/governmentLevels';

export default {
  name: 'BudgetSources',
  mixins: [alertMixin],
  props: {
    item: {
      type: Object,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    fullNumber() {
      const safe = (v) => (v !== null && v !== undefined ? String(v) : ''); // reemplazo de ISNULL

      if (this.item.programType.id === governmentLevels.State) {
        return [
          safe(this.item.account),
          safe(this.item.fund),
          safe(this.item.dept),
          safe(this.item.pcBusUnit),
          safe(this.item.class),
          safe(this.item.budRef),
        ].join('-');
      }

      if (this.item.programType.id === governmentLevels.Federal) {
        return [
          safe(this.item.account),
          safe(this.item.dept),
          safe(this.item.fund),
          safe(''),
          safe(this.item.class),
          safe(this.item.budRef),
          safe(this.item.pcBusUnit),
          safe(this.item.project),
        ].join('-');
      }

      return '';
    },
  },
  methods: {
    remove() {
      this.$emit('remove', this.item);
    },
  },
};
</script>
<style scoped>
.label {
  font-size: 16px !important;
  color: #727272 !important;
  margin-right: 5px;
}

.div-container {
  padding: 20px;
  background: white;
  border-radius: 4px;
  outline: 1px solid #e2e2e2;
  outline-offset: -1px;
}

.d-flex {
  align-items: center;
  min-height: 100%;
}

.row {
  align-items: center;
}
</style>
